import { ValidationError } from '@tanstack/react-form'
import { ReactNode } from 'react'
import { GenericField, GenericFieldSizing, GenericInput } from './generic'

export interface TextFieldProps {
	label: ReactNode
	onChange: (val: string) => void
	onBlur?: () => void
	onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void
	value: string
	type?: 'text' | 'email' | 'password'
	placeholder?: string
	autocomplete?: HTMLInputElement['autocomplete']
	hint?: ReactNode
	isGenerating?: boolean
	errors?: Array<ValidationError>
	disabled?: boolean
	isWaiting?: boolean
	toolbar?: ReactNode // Button space after the input
	sizing?: GenericFieldSizing
	maxLength?: number
}

export function TextField(
	{
		label,
		onChange,
		value,
		type = 'text',
		placeholder = '',
		onBlur = () => {},
		onKeyDown,
		autocomplete = 'off',
		hint,
		isGenerating = false,
		errors = [],
		disabled = false,
		isWaiting = false,
		toolbar,
		sizing = 'medium',
		maxLength,
	}: TextFieldProps,
) {
	const composedHint = maxLength != null
		? (
			<span className="flex justify-between">
				<span>{hint}</span>
				<span>{value.length}/{maxLength}</span>
			</span>
		)
		: hint

	return (
		<GenericField label={label} errors={errors} hint={composedHint} sizing={sizing}>
			<GenericInput isGenerating={isGenerating} isLoading={false} isDisabled={disabled} isWaiting={isWaiting}>
				{({ className }) => (
					<input
						className={className}
						type={type}
						value={value}
						onChange={(e) => onChange(e.target.value)}
						onBlur={onBlur}
						onKeyDown={onKeyDown}
						placeholder={placeholder}
						autoComplete={autocomplete}
						disabled={isGenerating || disabled || isWaiting}
					/>
				)}
			</GenericInput>
			{toolbar}
		</GenericField>
	)
}
